import { computed } from 'vue';
import { propOr } from 'ramda';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';

const useVerifyKey = () => {
  const {
    endpointData, callEndpoint, userFriendlyError, isLoading,
  } = useCallEndPointWith('verifyKey');

  const fetch = async (key) => {
    isLoading.value = true;
    await callEndpoint({
      method: 'POST',
      request: {
        key,
      },
    });
  };

  const response = computed(() => ({
    key: propOr('', 'key', endpointData.value),
    type: propOr('', 'type', endpointData.value),
    discount: propOr('', 'discount', endpointData.value),
    extraSeats: propOr('', 'extraSeats', endpointData.value),
  }));

  return {
    fetch, response, isLoading, userFriendlyError,
  };
};

export default useVerifyKey;
